import FormBase from "./base.vue";
import FormError from "./error.vue";
import FormInput from "./input.vue";
import FormVat from "./vat.vue";
import FormPhone from "./phone.vue";
import FormDate from "./date.vue";
import FormAddress from "./address.vue";
import Loader from "./loader.vue";
import FormTextarea from "./textarea.vue";
import FormSelect from "./select.vue";
import FormMultiSelect from "./multi-select.vue";
import FormFile from "./file.vue";

import FromJobToolzMultipleChoice from "./jobToolz/multiple_choice.vue";
import FromJobToolzExperience from "./jobToolz/experience.vue";
import FromJobToolzEducation from "./jobToolz/education.vue";
import FromJobToolzYesNo from "./jobToolz/yes_no.vue";

import FormSubmit from "./submit.vue";

export { FormBase, FormError, FormInput, FormVat, FormPhone, FromJobToolzMultipleChoice, FromJobToolzExperience, FromJobToolzEducation, FromJobToolzYesNo, FormDate, FormSelect, FormMultiSelect, FormTextarea, FormFile, FormSubmit, Loader };
